export default "__VITE_ASSET__80077677__"